import React from 'react';
import styled from 'styled-components';
import { useNavigate } from 'react-router-dom';
import { Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import Button from '@ui-elements/Button';
import { PALETTE, FONT_WEIGHTS } from '~/assets/styles/base';
import { ROUTES } from '~/constants/routes';

const StyledBox = styled.div`
  background: ${PALETTE.white};
  width: 806px;
  border: 1px solid ${PALETTE.border.frame};
  margin: 231px auto;
  padding: 86px 0;
  text-align: center;
`;

const Title = styled(Typography)`
  margin-bottom: 24px;
`;

const SurveyRegisterButton = styled(Button)`
  margin-top: 20px;
  font-weight: ${FONT_WEIGHTS.base};
  word-break: keep-all;
  min-width: 217px;
  &.MuiButton-sizeMedium {
    height: 32px;
  }
`;

const SignupError = (): JSX.Element => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const handleClick = () => {
    navigate(ROUTES.USER.SIGNUP);
  };

  return (
    <StyledBox>
      <Title variant="body5" data-testid="PagesErrorTitle">
        {t('error.signupError.title')}
      </Title>
      <Typography component="p" variant="bodyDefault" data-testid="PagesErrorMessage">
        {t('error.signupError.message')}
      </Typography>
      <SurveyRegisterButton
        color="secondary"
        colorType="navy"
        variant="outlined"
        handleClick={handleClick}
        data-testid="surveyRegisterButton"
      >
        {t('error.signupError.button')}
      </SurveyRegisterButton>
    </StyledBox>
  );
};

export default SignupError;
